import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { ReactiveFormsModule } from '@angular/forms'
import { FlexLayoutModule } from '@ngbracket/ngx-layout'

import { MaterialModule } from '../material/material.module'
import { ComponentsModule } from '../components/components.module'
import { WidgetsModule } from '../widgets/widgets.module'

import { ConfirmationComponent } from './confirmation/confirmation.component'
import { DialogWrapperComponent } from './dialog-wrapper.component'
import { MessageDialogComponent } from './message-dialog/message-dialog.component'
import { DeviceInstallUninstallDialogComponent } from './device-install-uninstall-dialog/device-install-uninstall-dialog.component'
import { AssetPairUnpairDialogComponent } from './asset-pair-unpair-dialog/asset-pair-unpair-dialog.component'
import { DirectiveModule } from '../directives/directive.module'
import { LinkDeviceToSensorDialogComponent } from './link-device-to-sensor-dialog/link-device-to-sensor-dialog.component'
import { AddNoteDialogComponent } from './add-note-dialog/add-note-dialog.component'
import { InputMessageDialogComponent } from './input-message-dialog/input-message-dialog.component'
import { InstallDateCorrectionDialogComponent } from './install-date-correction-dialog/install-date-correction-dialog.component'
import { CheckDeviceStatusDialogComponent } from './check-device-status-dialog/check-device-status-dialog.component'
import { PipesModule } from '@app/modules/client/shared/pipes/pipes.module'
import { PipesModule as CustomPipesModule } from './../pipes/pipes.module'
import { DuplicateDialogComponent } from './duplicate-dialog/duplicate-dialog.component'
import { InfoDialogComponent } from './info-dialog/info-dialog.component'
import { DeviceReplaceDialogComponent } from './device-replace-dialog/device-replace-dialog.component'
import { AssignRouteDialogComponent } from './assign-route-dialog/assign-route-dialog.component'
import { UninstallDialogComponent } from './uninstall-dialog/uninstall-dialog.component'
import { BulkUpdateDialogComponent } from './bulk-update-dialog/bulk-update-dialog.component'
import { ImportAssignmentsDialogComponent } from './import-assignments-dialog/import-assignments-dialog.component'

@NgModule({
  declarations: [
    ConfirmationComponent,
    DialogWrapperComponent,
    MessageDialogComponent,
    DeviceInstallUninstallDialogComponent,
    AssetPairUnpairDialogComponent,
    LinkDeviceToSensorDialogComponent,
    AddNoteDialogComponent,
    InputMessageDialogComponent,
    InstallDateCorrectionDialogComponent,
    CheckDeviceStatusDialogComponent,
    InfoDialogComponent,
    DuplicateDialogComponent,
    DeviceReplaceDialogComponent,
    AssignRouteDialogComponent,
    UninstallDialogComponent,
    BulkUpdateDialogComponent,
    ImportAssignmentsDialogComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    TranslateModule.forChild(),
    ComponentsModule,
    WidgetsModule,
    DirectiveModule,
    ReactiveFormsModule,
    PipesModule,
    CustomPipesModule,
  ],
  exports: [],
})
export class DialogsModule {}
